import * as React from 'react';
import { Button } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useIntl } from 'react-intl';
import SearchInput from '../../../components/search-input';
import { DropdownBody, Dropdown, DropdownToggle } from '../../../components/dropdown';
import styles from './styles.module.scss';

interface DocumentTemplateModalFiltersProps {
  filterText: string;
  setFilterText: (text: string) => void;
  creators: any[];
  selectedCreator: string;
  setSelectedCreator: (creator: string) => void;
}

export function DocumentTemplateModalFilters({
  filterText,
  setFilterText,
  creators,
  selectedCreator,
  setSelectedCreator,
}: DocumentTemplateModalFiltersProps) {
  const { formatMessage } = useIntl();
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  return (
    <Row className="justify-content-start">
      <Col xs={12} sm={8} md={8}>
        <SearchInput
          className={styles.templateSearch}
          value={filterText}
          name="template-search"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setFilterText(event.currentTarget.value)}
          placeholder={formatMessage({
            id: 'lease.filter.name.placeholder',
            defaultMessage: 'Search by template name',
          })}
          aria-label={formatMessage({
            id: 'lease.filter.name.label',
            defaultMessage: 'Template name',
          })}
          data-testid="template-search"
        />
      </Col>
      <Col xs={12} sm={4} md={4} className="mt-2 mt-sm-0">
        <Dropdown show={dropdownOpen} onToggle={setDropdownOpen}>
          <Dropdown.Toggle
            id="dropdown-filter-creators"
            as={DropdownToggle}
            className={'w-100'}
            contentClassName={styles.creatorDropdownText}
          >
            Creator: {selectedCreator || 'Select Creator'}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <DropdownBody>
              {[...creators].sort().map((creator) => (
                <Dropdown.Item
                  key={creator}
                  as={Button}
                  variant="link"
                  onClick={() => {
                    setSelectedCreator(creator);
                    setDropdownOpen(false); // Close dropdown after selection
                  }}
                  className={selectedCreator === creator ? 'font-weight-bold' : ''}
                >
                  {creator}
                </Dropdown.Item>
              ))}
            </DropdownBody>
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
}
